import { render, staticRenderFns } from "./s04-documentation.vue?vue&type=template&id=35de8f34&scoped=true"
import script from "./s04-documentation.vue?vue&type=script&lang=js"
export * from "./s04-documentation.vue?vue&type=script&lang=js"
import style0 from "./s04-documentation.vue?vue&type=style&index=0&id=35de8f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de8f34",
  null
  
)

export default component.exports